import {
    SET_FEVICYRL_CONTENT_SUCCESS,
    SET_WORKSHOP_LIST_SUCCESS,
    SET_WORKSHOP_CMDI_LIST_SUCCESS,
    SET_PAYMENT_LIST_SUCCESS,
    SET_WORKSHOP_AMMD_LIST_SUCCESS,
    SET_PAYMENT_AMMD_LIST_SUCCESS,
    SET_MY_DATABASE_SUCCESS,
} from '../constants/action-types';

export const setFevicyrlContent = (data) => {
    return {
        type: SET_FEVICYRL_CONTENT_SUCCESS,
        payload: data,
    };
};

export const setWorkshopList = (data) => {
    return {
        type: SET_WORKSHOP_LIST_SUCCESS,
        payload: data,
    };
};

export const setWorkshopCmdiList = (data) => {
    return {
        type: SET_WORKSHOP_CMDI_LIST_SUCCESS,
        payload: data,
    };
};

export const setPaymentList = (data) => {
    return {
        type: SET_PAYMENT_LIST_SUCCESS,
        payload: data,
    };
};

export const setWorkshopAmmdList = (data) => {
    return {
        type: SET_WORKSHOP_AMMD_LIST_SUCCESS,
        payload: data,
    };
};

export const setPaymentAmmdList = (data) => {
    return {
        type: SET_PAYMENT_AMMD_LIST_SUCCESS,
        payload: data,
    };
};

export const setMyDatabaseList = (data) => {
    return {
        type: SET_MY_DATABASE_SUCCESS,
        payload: data,
    };
};
